import { FALLBACK_SEPARATOR } from './constants';
import { isCssVarFunc } from './is-css-variable-function';
/**
 * Obtain the fallback value from a given CSS variable function call
 *
 * @param cssVarFunc CSS variable function with fallback, e.g. `var(--variable, fallback)`
 * @returns Fallback value or null if unavailable
 */
export function cssVarFuncFallback(cssVarFunc) {
    if (!isCssVarFunc(cssVarFunc) || !cssVarFunc.includes(FALLBACK_SEPARATOR)) {
        return null;
    }
    // Split the string after the ` and before the comma separating the CSS variable and fallback value
    return cssVarFunc
        .slice(cssVarFunc.indexOf(FALLBACK_SEPARATOR) + 1, -1)
        .trim();
}
